import { useSearchParams } from 'react-router';
import { useEffect, useCallback } from 'react';

const STORAGE_KEY = 'redirectAfterAuth';

export function useRedirectParam() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectParam = searchParams.get('redirect');
    if (redirectParam) {
      sessionStorage.setItem(STORAGE_KEY, redirectParam);
    }
  }, [searchParams]);

  const getRedirect = useCallback(() => {
    return sessionStorage.getItem(STORAGE_KEY);
  }, []);

  const consumeRedirect = useCallback(() => {
    const redirect = sessionStorage.getItem(STORAGE_KEY);
    if (redirect) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    return redirect;
  }, []);

  return { getRedirect, consumeRedirect };
}
